export enum Sections {
	AboutMe = 'AboutMe',
	Certificates = 'Certificates',
	Contact = 'Contact',
	Counter = 'Counter',
	Experience = 'Experience',
	Footer = 'Footer',
	Hero = 'Hero',
	Projects = 'Projects',
	Skills = 'Skills',
}

export enum Routes {
	Home = '/',
	NotFound = '*',
	Projects = '/projects',
}
